const SubmitGame = async (dataToSend) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}PluckingTheRooster/submit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        });

        // Manejo específico para validaciones de negocio del Backend (ej. 409 Conflict)
        if (response.status === 409) {
            return { success: false, status: 409, message: 'Duplicate entry' };
        }

        if (!response.ok) {
            return { success: false, status: response.status, message: 'Server error' };
        }

        // Si es 200 OK, parseamos la respuesta
        const data = await response.json();
        return { success: true, data: data };

    } catch (error) {
        // Error de red (sin internet, servidor caído)
        return { success: false, status: 0, message: 'Network error' };
    }
};

const ValidatePlayer = async (email, phone) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}PluckingTheRooster/check`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: email, phoneNumber: phone })
        });

        if (response.status === 409) {
            return { success: false, status: 409, message: 'Ya jugado' };
        }
        
        if (!response.ok) {
            return { success: false, status: response.status, message: 'Error server' };
        }

        return { success: true };
    } catch (error) {
        return { success: false, status: 0, message: 'Error red' };
    }
};

const ShowOverlay = async () => {
    try {
        await fetch(`${process.env.REACT_APP_API_URL}PluckingTheRooster/overlay/show`, { method: 'POST' });
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

const HideOverlay = async () => {
    try {
        await fetch(`${process.env.REACT_APP_API_URL}PluckingTheRooster/overlay/hide`, { method: 'POST' });
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

const RefreshOverlay = async () => {
    try {
        await fetch(`${process.env.REACT_APP_API_URL}PluckingTheRooster/overlay/refresh`, { method: 'POST' });
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

const ConfigOverlay = async (data) => {
    try {
        await fetch(`${process.env.REACT_APP_API_URL}PluckingTheRooster/overlay/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

const ConfigGame = async (data) => {
    try {
        await fetch(`${process.env.REACT_APP_API_URL}PluckingTheRooster/config-game`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

const ResetGame = async () => {
    try {
        // Asumiendo que crearás este endpoint en el controller si no lo tienes
        await fetch(`${process.env.REACT_APP_API_URL}PluckingTheRooster/reset`, { method: 'POST' }); 
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

export { SubmitGame, ValidatePlayer, ShowOverlay, HideOverlay, RefreshOverlay, ConfigOverlay, ConfigGame, ResetGame };









// const SubmitGame = async () => {
//     try {
//         const dataToSend = {
//             id: id
//         }

//         const response = await fetch(`${process.env.REACT_APP_API_URL}submit`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(dataToSend)
//         })

//         if (!response.ok) {
//             return { success: false, message: response.message }
//         }

//         //const data = JSON.parse(response.data)

//         return { success: true, data: null }
//     } catch (error) {
//         return { success: false, message: 'Ha habido un error al intentar enviar tu puntuación. Actualiza la página' };
//     }
// };

//export { SubmitGame };